import API from '@/services/API'
import store from '@/store/store'
import router from '@/router'

export default {
	async login (credentials) {
		try {
			const response = await API.post('login', credentials)
			return response.data
		} catch (err) {
			if (err.response.data.error) return err.response.data
			else throw (err)
		}
	},
	async register (credentials) {
		try {
			const response = await API.post('register', credentials)
			return response
		} catch (err) {
			throw (err)
		}
	},
	logout () {
		// Redirect to the homepage
		router.push('/')
		// Reset the authentication state
		store.dispatch('logout')
	},
	async forgotPassword (email) {
		return API.post('user/forgot-password', { email })
	},
	async sendVerification (email) {
		return API.post('user/send-verification', { email })
	},
	async verifyAccount (token) {
		try {
			const response = await API.post('/verify', {}, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			return response.data
		} catch (err) {
			alert(err)
		}
	}
}
